import { useEffect, useState } from 'react';
import AddMediaIcon from '../../../assets/icon/add-media.png';
import EditorComponent from 'components/Editor';
import './AddWebPagesForm.css';
import { Button, Input, Upload } from 'antd';
import { imgUrl } from 'utils/url';

const AddSection = ({ onAdd, selectedTemplate }) => {
  useEffect(() => {
    if (!selectedTemplate) return;

    setSectionId(selectedTemplate.sectionId || '');
    setTitle(selectedTemplate.title || '');
    setContent(selectedTemplate.content || '');
    setButtonText(selectedTemplate.button?.text || '');
    setButtonUrl(selectedTemplate.button?.url || '');

    // load image lama dari backend
    if (selectedTemplate.image) {
      setImagePreview(`${imgUrl}/media/${selectedTemplate.image}`);
    }
  }, [selectedTemplate]);

  console.log(selectedTemplate, 'selectedTemplate');

  const [sectionId, setSectionId] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [errors, setErrors] = useState({});

  const [imageFile, setImageFile] = useState();
  const [imagePreview, setImagePreview] = useState(null);
  const [buttonText, setButtonText] = useState('Learn More');
  const [buttonUrl, setButtonUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!sectionId.trim()) {
      newErrors.sectionId = 'Section ID is required';
    }

    if (!title.trim()) {
      newErrors.title = 'Title is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!selectedTemplate) {
      newErrors.template = 'Please select a template';
    }

    const newSection = {
      id: selectedTemplate?.id || Date.now(),
      sectionId,
      title,
      content,
      template: selectedTemplate,
      file: imageFile,
      image: selectedTemplate?.image,
      button: {
        text: buttonText,
        url: buttonUrl,
      },
    };

    if (onAdd) {
      onAdd(newSection, selectedTemplate);
    }

    // reset form
    setSectionId('');
    setTitle('');
    setContent('');
    setErrors({});
  };

  const handleMediaChange = (e) => {
    const files = Array.from(e.target.files);

    const mappedFiles = files.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      name: file.name,
      preview: URL.createObjectURL(file),
    }));

    setImageFile(mappedFiles);
    setImagePreview(mappedFiles[0].preview);
  };

  const handleRemoveImage = () => {
    if (imageFile && imageFile[0]?.preview) {
      URL.revokeObjectURL(imageFile[0].preview);
    }

    setImageFile(null);
    setImagePreview(null);
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        paddingLeft: '12px',
      }}
    >
      <span
        style={{
          fontWeight: '700',
          fontSize: '24px',
        }}
      >
        Add Section
      </span>
      <form className="form-wrapper" onSubmit={handleSubmit}>
        <div>
          <div className="form">
            <label className="form-label">
              Section ID <span className="is-required">*</span>
            </label>
            <Input
              placeholder="Section ID"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              name="name"
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          <div className="form">
            <label className="form-label">Title</label>
            <Input
              placeholder="Title"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              name="name"
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          <div className="form">
            <label className="form-label">Section Image</label>

            <input
              type="file"
              multiple
              accept="image/*,video/*"
              id="media-upload"
              style={{ display: 'none' }}
              onChange={handleMediaChange}
            />
            <Button
              onClick={() => document.getElementById('media-upload').click()}
              type="dashed"
            >
              + Add Image
            </Button>
            {/* </Upload> */}

            {(imagePreview || imageFile) && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: '12px',
                }}
              >
                <img
                  src={imageFile ? imageFile[0].preview : imagePreview}
                  alt="preview"
                  style={{
                    width: '100%',
                    maxWidth: '250px',
                    borderRadius: '6px',
                    border: '1px solid #ddd',
                  }}
                />

                <Button
                  danger
                  style={{ marginTop: '8px', width: '120px' }}
                  onClick={handleRemoveImage}
                >
                  Remove Image
                </Button>
              </div>
            )}
          </div>

          <div className="form">
            <label className="form-label">Button Text</label>
            <Input
              placeholder="Button Text"
              value={buttonText}
              onChange={(e) => setButtonText(e.target.value)}
            />
          </div>

          <div className="form">
            <label className="form-label">Button URL</label>
            <Input
              placeholder="https://example.com"
              value={buttonUrl}
              onChange={(e) => setButtonUrl(e.target.value)}
            />
          </div>

          <div className="form">
            <EditorComponent value={content} onChange={setContent} />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          <div style={{ marginTop: '16px' }}>
            <Button type="primary" htmlType="submit">
              Save Section
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddSection;
